import { ApproveRejectDialogComponent } from './../approve-reject-dialog/approve-reject-dialog.component';
import { PendingApprovalDialogComponent } from './../pending-approval-dialog/pending-approval-dialog.component';
import { Component, OnInit, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { SearchTermservice } from '../../services/search/search-service.service';
import { DueDiligenceService } from '../../services/due-diligence/due-diligence.service';
import { DownloadService } from '../../services/download/download.service'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, Sort } from '@angular/material';
import { DueDiligenceDeleteDialogComponent } from '../../components/due-diligence-delete-dialog/due-diligence-delete-dialog.component';
import { DueDiligenceDialogComponent } from '../../components/due-diligence-dialog/due-diligence-dialog.component';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { PageEvent } from '@angular/material';
import { MatPaginatorIntl } from '@angular/material';
import { ViewChild } from '@angular/core';
import { DataSource } from '@angular/cdk/table';
import * as moment from 'moment';
import { GetDocStatusColor } from '../../../shared/globalService';
import { DisableRow } from '../../../shared/globalService';

@Component({
  selector: 'app-agent-due-diligence',
  templateUrl: './agent-due-diligence.component.html',
  styleUrls: ['./agent-due-diligence.component.css']
})
export class AgentDueDiligenceComponent implements OnInit {
  public documentsAllowedToUpload = [];
  public agentID: any;
  public agentDetails: any;
  public listOfDocType: any;
  public dueDocs: any;
  ispaginationFlag: boolean = false;
  public data: boolean = true;
  documentType: any;
  pageSize = 10;
  message: any;
  noResults: any;
  length: any;
  clientDisable: any;
  clientHidden: any;
  public role: string;
  sortedData;
  docCategory: any;
  selectedDocumentType: any;
  DocTypeErrMsg;
  DocTypeErr: boolean = false;
  dataNotFound: boolean = false;
  dataNotFoundMsg;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  vendorName;
  uploadedFileName;
  placeholder = "Select a Document";
  displayedColumns = ['DocumentTypeName', 'FileName', 'ExpirationDate', 'UploadedTimeStamp', 'DocumentStatus', 'FileEdit'];
  dataSource: MatTableDataSource<UserData>;
  pageEvent: PageEvent;
  grey: boolean = false;
  approve_reject_button: boolean = false;
  disable_edit: boolean = false;

  constructor(private downloadService: DownloadService,
    private dueDiligenceService: DueDiligenceService,
    private searchTermservice: SearchTermservice,
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private getDocStatusColor: GetDocStatusColor,
    private disabletheRow: DisableRow) { }

  ngOnInit() {
    this.vendorName = localStorage.getItem('AgentName');
    this.agentID = localStorage.getItem("AgentId");
    this.role = localStorage.getItem("Role");
    this.refresh();
    if (this.role === "PC Client") {
      this.clientDisable = true;
      this.clientHidden = true;
    } else {
      this.clientDisable = false;
      this.clientHidden = false;
    }
  }

  refresh() {
    // List of Document types method
    this.dueDiligenceService.listOfDocuments().subscribe(res => {
      if (res.DocumentTypes !== undefined && res.DocumentTypes.length <= 0) {
        this.dataNotFoundMsg = "document types data not found";
        this.dataNotFound = true;
      } else {
        this.listOfDocType = res.DocumentTypes;
        this.docCategory = this.listOfDocType[0].Category;
        this.populateDocumentTypeDropDown()
      }
    }, error => {
      this.DocTypeErrMsg = 'Due Diligence Service' + ' ' + error;;
      this.DocTypeErr = true;
    });

    this.dueDiligenceService.load.subscribe(res => {
      if (res === 'success') {
        this.selectedDocumentType = '';
        this.getDocDetails();
      }
    });

    this.searchTermservice.detailsOfAgent(this.agentID).subscribe(res => {
      this.agentDetails = res;
      localStorage.setItem('AgentName', this.agentDetails.name)
      this.getDocDetails();
    });
  }

  populateDocumentTypeDropDown() {
    const documentTypeFilter = () => true;
    this.documentsAllowedToUpload = this.filterDocumentTypesBy(documentTypeFilter)
  }

  filterDocumentTypesBy(filterDocumentsPredicate) {
    return this.listOfDocType.filter(filterDocumentsPredicate)
  }

  placeholderChange() {
    this.placeholder = "Document";
  }

  getDocDetails() {
    this.dueDiligenceService.getDueDocuments(this.agentID).subscribe(res => {
      if (res.Documents !== undefined && res.Documents.length <= 0) {
        this.dueDocs = [];
        this.ispaginationFlag = false;
        this.dataSource = null;
        this.noResults = "No documents found";
      } else {
        this.noResults = '';
        this.dueDocs = res.Documents;
        for (let i = 0; i < this.dueDocs.length; i++) {
          if (this.dueDocs[i].ExpirationDate !== '' && this.dueDocs[i].ExpirationDate !== null && this.dueDocs[i].ExpirationDate !== undefined) {
            var momentDate = moment(this.dueDocs[i].ExpirationDate).format('YYYY/MM/DD');
            this.dueDocs[i].ExpirationDate = momentDate;
          }
          if (this.dueDocs[i].UploadedTimeStamp != '' && this.dueDocs[i].UploadedTimeStamp != null && this.dueDocs[i].UploadedTimeStamp != undefined) {
            var momentDate = moment(this.dueDocs[i].UploadedTimeStamp).format('YYYY/MM/DD');
            this.dueDocs[i].UploadedTimeStamp = momentDate;
          }
        }

        this.dataSource = new MatTableDataSource(this.dueDocs);
        this.dataSource.sort = this.sort;
        this.length = this.dueDocs.length;
        if (this.length <= 10) {
          this.ispaginationFlag = false;
        } else {
          this.ispaginationFlag = true;
        }
        if (this.paginator.pageIndex > 0 && (this.length % 10 == 0)) {
          this.paginator.pageIndex = this.paginator.pageIndex - 1;
        }
        this.dataSource.paginator = this.paginator;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) { return `0 van ${length}`; }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
          const round = Math.ceil(length / 10)
          return `${(startIndex / 10) + 1}  of ${round}`;
        }
        this.dataSource.paginator._intl = paginatorIntl;
      }
    }, error => {
      this.DocTypeErrMsg = 'Due Diligence Service' + ' ' + error;
      this.DocTypeErr = true;
    });
  }

  getColor(expirationDate) {
    let todayDate = new Date()
    let currentDate = new Date().setHours(0, 0, 0, 0);
    var targetDate = new Date();
    let futureDate = targetDate.setDate(todayDate.getDate() + 30);
    let future = new Date(futureDate).setHours(0, 0, 0, 0);
    let expDate = new Date(expirationDate).setHours(0, 0, 0, 0);
    if (expDate < currentDate) {
      return "red";
    }
    else if (expDate > future) {
      return "black";
    }
    else {
      return "blue";
    }
  }

  openDialog(docName, type): void {
    docName.DocumentCategory = this.docCategory;
    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: docName.DocumentTypeName,
      DocumentTypeCode: docName.DocumentTypeCode,
      DocumentCategory: docName.DocumentCategory
    };
    var Data;
    let dialogRef = this.dialog.open(DueDiligenceDialogComponent, {
      width: '600px',
      height: '600px',
      data: { data: type === 'update' ? docName : new_Data, type: type, agent_name: this.agentDetails.name }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedDocumentType = '';
      this.placeholder = "Select a Document"
    });
    localStorage.setItem('documentnName', docName);
  }

  validateDoc(name, type): void {
    name.DocumentCategory = this.docCategory;

    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: name.DocumentTypeName,
      DocumentTypeCode: name.DocumentTypeCode,
      DocumentCategory: name.DocumentCategory
    };
    var Data;

    this.clientHidden = false;
    let dialogRef = this.dialog.open(PendingApprovalDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? name : new_Data, type: type, agent_name: this.agentDetails.name, pagename: 'due-diligence' },
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  editDoc(docName) {
    localStorage.setItem('old', JSON.stringify(docName));
    if (docName.DocumentStatus === "Pending Approval" && (this.role === "PC Site Admin" || this.role === "PC PAR Admin" || this.role === "PC PAR Vendor Relations")) {
      this.validateDoc(docName, 'update');
    } else {
      this.openDialog(docName, 'update');
    }
  }

  doctypeChange(name) {
    this.openDialog(name, 'create');
  }

  deleteDoc(doc) {
    doc.DocumentCategory = this.docCategory;
    let dialogRef = this.dialog.open(DueDiligenceDeleteDialogComponent, {
      width: '400px',
      height: '250px',
      data: doc
    });
  }

  convertToDate(expirationDate) {
    if (expirationDate !== null && expirationDate !== '') {
      const expiration = new Date(expirationDate);
      if (expiration !== undefined) {
        return expiration.getMonth() + 1 + "/" + expiration.getDate() + "/" + expiration.getFullYear();
      }
      return expirationDate;
    }
  }

  // Get the status color
  getStatusColor(status, updatedBy) {
    let response = this.getDocStatusColor.getStatusColor(status, updatedBy);
    this.approve_reject_button = response['Approve/Reject Button'];
    return response.CSS;
  }

  // Greyout the row if the ststus is in inprogress
  disableRow(status, updatedBy) {
    let response = this.disabletheRow.disableRow(status, updatedBy);
    this.grey = response['Disable'];
    this.disable_edit = response['Disable_Edit'];
    return response.CSS;
  }

  doApproveRejectDialog(docName, type): void {
    docName.DocumentCategory = this.docCategory;

    var new_Data = {
      AGENT_ID: localStorage.getItem('AgentId'),
      DocumentTypeName: docName.DocumentTypeName,
      DocumentTypeCode: docName.DocumentTypeCode,
      DocumentCategory: docName.DocumentCategory
    };
    var Data;

    this.clientHidden = false;
    let dialogRef = this.dialog.open(ApproveRejectDialogComponent, {
      disableClose: true,
      height: '300px',
      width: '600px',
      data: { data: type === 'update' ? docName : new_Data, type: type, agent_name: this.agentDetails.name, pagename: 'due-diligence' },

    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  doApproveReject(docName) {
    this.doApproveRejectDialog(docName, 'update');
  }
}

export interface UserData {
  DocumentTypeName: String;
  FileName: String;
  ExpirationDate: Date;
  UploadedTimeStamp: Date;
  DocumentStatus: String;
  FileEdit: any;
}



// WEBPACK FOOTER //
// ./src/app/components/agent-due-diligence/agent-due-diligence.component.ts